import GlobalChatPage from './pages/GlobalChatPage'
import LabFinancePage from './pages/LabFinancePage'
import OrdersPage from './pages/OrdersPage'
import AdminOrdersPage from './pages/admin/AdminOrdersPage'
import {
  lazy,
  StrictMode,
  Suspense,
} from 'react'

import {
  createRoot,
} from 'react-dom/client'

import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom'

import {
  AdminGuard,
} from './components/admin/AdminGuard'

import {
  AdminLayout,
} from './components/admin/AdminLayout'

import {
  AchievementProvider,
} from './components/achievements/AchievementProvider'

import {
  CookieBanner,
} from './components/cookies/CookieBanner'

import {
  Header,
} from './components/header/Header'

import { HalloweenPumpkins } from './components/seasonal/HalloweenPumpkins'

import {
  DailyDropNotice,
} from './components/system/DailyDropNotice'

import {
  PageTransition,
} from './components/transitions/PageTransition'

import {
  useHeader,
} from './hooks/useHeader'


import './styles/global.css'
import './styles/header.css'
import './styles/live.css'
import './styles/cookies.css'
import './styles/login.css'
import './styles/registration.css'
import './styles/transitions.css'
import './styles/modules.css'
import './styles/module.css'
import './styles/game-dialog.css'
import './styles/achievements.css'
import './styles/achievements-page.css'
import './styles/library.css'
import './styles/cart.css'
import './styles/lab.css'
import './styles/stand.css'
import './styles/mystery-box.css'
import './styles/leaderboard.css'
import './styles/fractions.css'
import './styles/teams.css'
import TeamsPage, {TeamPage,TeamInvitePage} from './pages/TeamsPage'
import './styles/profile.css'
import './styles/settings.css'
import './styles/learn.css'
import './styles/eva-coach.css'
import './styles/notes-social.css'
import './styles/home.css'
import './styles/public-footer.css'
import './styles/terms-of-use.css'
import './styles/privacy.css'
import './styles/consent.css'
import './styles/confirm-registration.css'
import './styles/public-courses.css'
import './styles/public-course.css'
import './styles/career-tracks.css'
import './styles/certifications.css'
import './styles/support.css'
import './styles/reviews.css'
import './styles/admin-awards.css'
import './styles/admin-reviews.css'
import './styles/public-stands.css'
import './styles/roadmap.css'
import './styles/balance.css'
import './styles/daily.css'
import './styles/daily-notice.css'
import './styles/admin.css'
import './styles/admin-stands.css'
import './styles/admin-modules.css'
import './styles/admin-lessons.css'
import './styles/admin-drops.css'
import './styles/product.css'
import './styles/radio-player.css'
import './styles/assessment.css'
import './styles/knowledge.css'

const HomePage =
  lazy(
    () =>
      import(
        './pages/HomePage'
      ),
  )


const LoginPage =
  lazy(
    () =>
      import(
        './pages/LoginPage'
      ),
  )


const ResetPasswordPage =
  lazy(
    () =>
      import(
        './pages/ResetPasswordPage'
      ),
  )


const ForgotPasswordPage =
  lazy(
    () =>
      import(
        './pages/ForgotPasswordPage'
      ),
  )


const RegistrationPage =
  lazy(
    () =>
      import(
        './pages/RegistrationPage'
      ),
  )


const ModulesPage =
  lazy(
    () =>
      import(
        './pages/ModulesPage'
      ),
  )


const ModulePage =
  lazy(
    () =>
      import(
        './pages/ModulePage'
      ),
  )


const KnowledgePage = lazy(() => import('./pages/KnowledgePage'))

const LibraryPage =
  lazy(
    () =>
      import(
        './pages/LibraryPage'
      ),
  )


const CartPage =
  lazy(
    () =>
      import(
        './pages/CartPage'
      ),
  )


const LabPage =
  lazy(
    () =>
      import(
        './pages/LabPage'
      ),
  )


const StandPage =
  lazy(
    () =>
      import(
        './pages/StandPage'
      ),
  )


const MysteryBoxPage =
  lazy(
    () =>
      import(
        './pages/MysteryBoxPage'
      ),
  )


const LeaderboardPage =
  lazy(
    () =>
      import(
        './pages/LeaderboardPage'
      ),
  )


const FractionsPage =
  lazy(
    () =>
      import(
        './pages/FractionsPage'
      ),
  )


const ProfilePage =
  lazy(
    () =>
      import(
        './pages/ProfilePage'
      ),
  )


const SettingsPage =
  lazy(
    () =>
      import(
        './pages/SettingsPage'
      ),
  )


const LearnPage =
  lazy(
    () =>
      import(
        './pages/LearnPage'
      ),
  )


const TermsOfUsePage =
  lazy(
    () =>
      import(
        './pages/TermsOfUsePage'
      ),
  )


const PrivacyPage =
  lazy(
    () =>
      import(
        './pages/PrivacyPage'
      ),
  )


const ConsentPage =
  lazy(
    () =>
      import(
        './pages/ConsentPage'
      ),
  )


const ConfirmRegistrationPage =
  lazy(
    () =>
      import(
        './pages/ConfirmRegistrationPage'
      ),
  )


const PublicCoursesPage =
  lazy(
    () =>
      import(
        './pages/PublicCoursesPage'
      ),
  )


const PublicCoursePage =
  lazy(
    () =>
      import(
        './pages/PublicCoursePage'
      ),
  )


const CareerTracksPage =
  lazy(
    () =>
      import(
        './pages/CareerTracksPage'
      ),
  )


const CertificationsPage =
  lazy(
    () =>
      import(
        './pages/CertificationsPage'
      ),
  )


const SupportPage =
  lazy(
    () =>
      import(
        './pages/SupportPage'
      ),
  )


const ReviewsPage =
  lazy(
    () =>
      import(
        './pages/ReviewsPage'
      ),
  )


const PublicStandsPage =
  lazy(
    () =>
      import(
        './pages/PublicStandsPage'
      ),
  )


const ProductPage =
  lazy(
    () =>
      import(
        './pages/ProductPage'
      ),
  )


const RoadmapPage =
  lazy(
    () =>
      import(
        './pages/RoadmapPage'
      ),
  )


const BalancePage =
  lazy(
    () =>
      import(
        './pages/BalancePage'
      ),
  )


const PaymentReturnPage =
  lazy(
    () =>
      import(
        './pages/PaymentReturnPage'
      ),
  )


const DailyPage =
  lazy(
    () =>
      import(
        './pages/DailyPage'
      ),
  )


const AdminDashboardPage =
  lazy(
    () =>
      import(
        './pages/admin/AdminDashboardPage'
      ),
  )


const AdminComingSoonPage =
  lazy(
    () =>
      import(
        './pages/admin/AdminComingSoonPage'
      ),
  )



const BlogPage = lazy(() => import('./pages/BlogPage'))
const BlogArticlePage = lazy(() => import('./pages/BlogArticlePage'))
const AdminBlogPage = lazy(() => import('./pages/admin/AdminBlogPage'))
const AdminBlogEditorPage = lazy(() => import('./pages/admin/AdminBlogEditorPage'))

const AdminStandsPage = lazy(() => import('./pages/admin/AdminStandsPage'))
const AdminStandEditorPage = lazy(() => import('./pages/admin/AdminStandEditorPage'))

const AdminPathsPage = lazy(() => import('./pages/admin/AdminPathsPage'))

const AdminModulesPage =
  lazy(
    () =>
      import(
        './pages/admin/AdminModulesPage'
      ),
  )


const AdminModuleEditorPage =
  lazy(
    () =>
      import(
        './pages/admin/AdminModuleEditorPage'
      ),
  )

const AssessmentPage =
  lazy(() => import('./pages/AssessmentPage'))

const AchievementsPage =
  lazy(
    () =>
      import(
        './pages/AchievementsPage'
      ),
  )

const AdminLessonsPage =
  lazy(
    () =>
      import(
        './pages/admin/AdminLessonsPage'
      ),
  )


const AdminProductsPage =
  lazy(
    () =>
      import(
        './pages/admin/AdminProductsPage'
      ),
  )


const AdminAwardsPage =
  lazy(
    () =>
      import(
        './pages/admin/AdminAwardsPage'
      ),
  )

const AdminReviewsPage = lazy(() => import('./pages/admin/AdminReviewsPage'))

const AdminEmojisPage = lazy(() => import('./pages/admin/AdminEmojisPage'))

const AdminDropsPage =
  lazy(
    () =>
      import(
        './pages/admin/AdminDropsPage'
      ),
  )


const LivePage = lazy(() => import('./pages/LivePage'))

function App() {
  const location =
    useLocation()

  const {
    status,
    me,
    header,
    error,
    reload,
  } = useHeader()


  const isAdminPath =
    location.pathname === '/admin' ||
    location.pathname.startsWith(
      '/admin/',
    )


  return (
    <div
      className={
        isAdminPath
          ? 'kr-page kr-page--admin'
          : 'kr-page'
      }
    >
      {!isAdminPath && <HalloweenPumpkins />}

      {!isAdminPath && (
        <Header
          status={status}
          me={me}
          header={header}
          error={error}
          onRetry={reload}
        />
      )}


      <main
        className={
          isAdminPath
            ? (
                'kr-route-stage '
                + 'kr-route-stage--admin'
              )
            : 'kr-route-stage'
        }
      >
        <Suspense
          fallback={null}
        >
          <Routes>
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogArticlePage />} />

            <Route
              path="/admin"
              element={
                <AdminGuard
                  status={status}
                  me={me}
                >
                  {me ? (
                    <AdminLayout
                      me={me}
                    />
                  ) : null}
                </AdminGuard>
              }
            >

              <Route
                index
                element={
                  <AdminDashboardPage />
                }
              />


              <Route path="paths" element={<AdminPathsPage />} />
              <Route path="blog" element={<AdminBlogPage />} />
              <Route path="blog/new" element={<AdminBlogEditorPage />} />
              <Route path="blog/:id" element={<AdminBlogEditorPage />} />
              <Route path="stands" element={<AdminStandsPage />} />
              <Route path="finance" element={<LabFinancePage />} />
              <Route path="stands/new" element={<AdminStandEditorPage />} />
              <Route path="stands/:standId" element={<AdminStandEditorPage />} />

              <Route
                path="modules"
                element={
                  <AdminModulesPage />
                }
              />


              <Route
                path="modules/:moduleId"
                element={
                  <AdminModuleEditorPage />
                }
              />


              <Route
                path="modules/:moduleId/lessons"
                element={
                  <AdminLessonsPage />
                }
              />


              <Route
                path="store/products"
                element={
                  <AdminProductsPage />
                }
              />


              <Route
                path="store/orders"
                element={
                  <AdminOrdersPage />
                }
              />


              <Route
                path="store/delivery"
                element={
                  <AdminComingSoonPage />
                }
              />


              <Route
                path="store/promocodes"
                element={
                  <AdminComingSoonPage />
                }
              />


              <Route path="emojis" element={<AdminEmojisPage />} />
              <Route path="reviews" element={<AdminReviewsPage />} />

              <Route
                path="awards"
                element={
                  <AdminAwardsPage />
                }
              />


<Route
  path="drops"
  element={
    <AdminDropsPage />
  }
/>

            </Route>


            <Route
              path="/"
              element={
                <PageTransition>
                  <HomePage
                    status={status}
                    me={me}
                  />
                </PageTransition>
              }
            />


            <Route path="/live/" element={status === 'guest' ? <Navigate to="/login/" replace /> : status === 'authenticated' ? <PageTransition><LivePage /></PageTransition> : null} />

            <Route
              path="/login/"
              element={
                <PageTransition>
                  <LoginPage
                    status={status}
                    reloadAuth={reload}
                  />
                </PageTransition>
              }
            />


            <Route
              path="/registration/"
              element={
                <PageTransition>
                  <RegistrationPage
                    status={status}
                  />
                </PageTransition>
              }
            />


            <Route
              path="/kursy-kiberbezopasnosti/"
              element={
                <PageTransition>
                  <PublicCoursesPage />
                </PageTransition>
              }
            />


            <Route
              path="/kursy-kiberbezopasnosti/details/:slug"
              element={
                <PageTransition>
                  <PublicCoursePage />
                </PageTransition>
              }
            />


            <Route
              path="/kursy-kiberbezopasnosti/paths/"
              element={
                <PageTransition>
                  <CareerTracksPage />
                </PageTransition>
              }
            />


            <Route
              path="/sertifikaty-po-kiberbezopasnosti/"
              element={
                <PageTransition>
                  <CertificationsPage />
                </PageTransition>
              }
            />


            <Route
              path="/otzyvy/"
              element={
                <PageTransition>
                  <ReviewsPage />
                </PageTransition>
              }
            />


            <Route
              path="/ctf-standy/"
              element={
                <PageTransition>
                  <PublicStandsPage />
                </PageTransition>
              }
            />


            <Route
              path="/support/"
              element={
                <PageTransition>
                  <SupportPage />
                </PageTransition>
              }
            />


            <Route path="/assessement/" element={<Navigate to="/training/" replace />} />
            <Route
              path="/training/"
              element={
                <PageTransition>
                  <AssessmentPage />
                </PageTransition>
              }
            />


            <Route
              path="/modules/"
              element={
                <PageTransition>
                  <ModulesPage />
                </PageTransition>
              }
            />


            <Route
              path="/module/:id"
              element={
                <PageTransition>
                  <ModulePage />
                </PageTransition>
              }
            />


            <Route
              path="/paths/"
              element={
                <Navigate
                  to="/modules/?section=paths"
                  replace
                />
              }
            />


            <Route path="/knowledge/" element={<PageTransition><KnowledgePage /></PageTransition>} />

            <Route
              path="/dashboard/"
              element={
                <PageTransition>
                  <LibraryPage />
                </PageTransition>
              }
            />


            <Route
              path="/orders"
              element={<PageTransition><OrdersPage /></PageTransition>}
            />
            <Route
              path="/cart/"
              element={
                <PageTransition>
                  <CartPage />
                </PageTransition>
              }
            />


            <Route
              path="/learn/module/:moduleId"
              element={
                <PageTransition>
                  <LearnPage />
                </PageTransition>
              }
            />


            <Route
              path="/learn/module/:moduleId/section/:lessonId"
              element={
                <PageTransition>
                  <LearnPage />
                </PageTransition>
              }
            />


            <Route
              path="/lab/"
              element={
                <PageTransition>
                  <LabPage />
                </PageTransition>
              }
            />


            <Route
              path="/mystery-box/"
              element={
                <PageTransition>
                  <MysteryBoxPage />
                </PageTransition>
              }
            />


            <Route
              path="/machines/:standName"
              element={
                <PageTransition>
                  <StandPage />
                </PageTransition>
              }
            />


            <Route
              path="/leaderboard"
              element={
                <PageTransition>
                  <LeaderboardPage />
                </PageTransition>
              }
            />


            <Route path="/chat/" element={status === 'guest' ? <Navigate to="/login/" replace /> : status === 'authenticated' ? <PageTransition><GlobalChatPage /></PageTransition> : null} />
            <Route path="/teams/" element={<PageTransition><TeamsPage /></PageTransition>} />
            <Route path="/teams/invite/:token" element={<PageTransition><TeamInvitePage /></PageTransition>} />
            <Route path="/teams/:slug" element={<PageTransition><TeamPage /></PageTransition>} />
            <Route
              path="/fractions/"
              element={
                <PageTransition>
                  <FractionsPage />
                </PageTransition>
              }
            />


            <Route
              path="/profile/:username"
              element={
                <PageTransition>
                  <ProfilePage />
                </PageTransition>
              }
            />


            <Route
              path="/settings/"
              element={
                <PageTransition>
                  <SettingsPage />
                </PageTransition>
              }
            />


            <Route
              path="/terms-of-use/"
              element={
                <PageTransition>
                  <TermsOfUsePage />
                </PageTransition>
              }
            />


            <Route
              path="/privacy/"
              element={
                <PageTransition>
                  <PrivacyPage />
                </PageTransition>
              }
            />


            <Route
              path="/consent/"
              element={
                <PageTransition>
                  <ConsentPage />
                </PageTransition>
              }
            />


            <Route
              path="/registration/confirm"
              element={
                <PageTransition>
                  <ConfirmRegistrationPage />
                </PageTransition>
              }
            />


            <Route
              path="/registration/confirm/"
              element={
                <PageTransition>
                  <ConfirmRegistrationPage />
                </PageTransition>
              }
            />


            <Route
              path="/payment/return/"
              element={
                <PaymentReturnPage />
              }
            />


            <Route
              path="/payment/return/success/"
              element={
                <PaymentReturnPage />
              }
            />


            <Route
              path="/payment/return/fail/"
              element={
                <PaymentReturnPage />
              }
            />


            <Route
              path="/balance/"
              element={
                <PageTransition>
                  <BalancePage />
                </PageTransition>
              }
            />


            <Route
              path="/roadmap/:slug/"
              element={
                <PageTransition>
                  <RoadmapPage />
                </PageTransition>
              }
            />


            <Route
              path="/daily/"
              element={
                <PageTransition>
                  <DailyPage />
                </PageTransition>
              }
            />


            <Route
              path="/store/product/:slug"
              element={
                <PageTransition>
                  <ProductPage />
                </PageTransition>
              }
            />


            <Route
              path="/forgot-password/"
              element={
                <PageTransition>
                  <ForgotPasswordPage />
                </PageTransition>
              }
            />


            <Route
              path="/reset-password/"
              element={
                <PageTransition>
                  <ResetPasswordPage />
                </PageTransition>
              }
            />

<Route
  path="/achievements/"
  element={
    <PageTransition>
      <AchievementsPage />
    </PageTransition>
  }
/>

       </Routes>
        </Suspense>
      </main>


      {!isAdminPath &&
        status === 'authenticated' &&
        me && (
          <DailyDropNotice
            status={status}
            me={me}
          />
        )}


      {!isAdminPath &&
        status === 'guest' && (
          <CookieBanner />
        )}
    </div>
  )
}


const rootElement =
  document.getElementById(
    'root',
  )


if (!rootElement) {
  throw new Error(
    'Root element #root not found',
  )
}


createRoot(
  rootElement,
).render(
  <StrictMode>
    <BrowserRouter>
      <AchievementProvider>
        <App />
      </AchievementProvider>
    </BrowserRouter>
  </StrictMode>,
)
